import React from "react";

function Error() {
  return (
    <div className="relative h-screen overflow-hidden">
      <div className="absolute top-48 left-36 bg-[#3B2E09] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />
      <div className="absolute top-2 right-52 bg-[#2C4146] w-[248px] h-[688.552px] rotate-[39.237deg] rounded-[50%] blur-[150px]" />

      <div className="z-20 flex flex-col items-center justify-center h-full mx-auto text-white">
        <h1 className="font-black tracking-wide text-9xl">
          {["4", "0", "4"].map((digit, index) => (
            <span
              key={index}
              className="inline-block transition-all duration-300 cursor-pointer hover:text-foreground hover:-translate-y-1"
            >
              {digit}
            </span>
          ))}
        </h1>
        <h2 className="mt-5 text-2xl font-semibold font-Gilroy">
          Page Not Found
        </h2>
        <p className="text-base font-medium text-[#7B7B7B] font-Gilroy md:mt-12 mt-7 max-w-md text-center">
          The page you are looking for is not found, please check your url and
          try again!
        </p>
      </div>
    </div>
  );
}

export default Error;
